import React from "react";
import { BrowserRouter as Router, Routes, Route,Navigate  } from "react-router-dom";
import Header from "../Components/Layout/Header";
import LanguageSwitcher from "../Common/LanguageSwitcher";
// import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../Components/Security/Login";
import Home from "../Components/Layout/Home";
import Home_W from "../Components/Layout/Home_W";
import PrivateLayout from "./PrivateLayout";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import RegistrationFormOne from "../Components/Registration/Registration_FormOne";
import Forgot_Password from '../Components/Security/Forgot_Password';
import RegistrationFormTwo from "../Components/Registration/Registration_FormTwo";
import RegistrationError from "../Components/Registration/Registration_Error";
import HealthProfileMultiStageForm from "../Components/HealthProfileSetup/HealthProfle_Multistage_Form";
import Gender from "../Components/HealthProfileSetup/Gender";
import HealthPlan from "../Components/HealthProfileSetup/Healthplans";
import Relationship from "../Components/HealthProfileSetup/Relationship";
import Pronouns from "../Components/HealthProfileSetup/Pronouns";
import FamilyBuildingGoals from "../Components/HealthProfileSetup/Family_Building_Goals";
import FamilyBuildingJourney from "../Components/HealthProfileSetup/Family_Building_Journey";
import AccessCodeForm from "../Components/Registration/AccessCode_Form";
import CompanyForm from "../Components/Registration/Company_Form";
import ContactWin from "../Components/Registration/Contact_Win";
import ContractsForm from "../Components/Registration/Contracts_Form";
import WinBenefitOptions from "../Components/Registration/Win_Benefit_Options";
import BookAppointment from "../Components/ScheduleAppointment/BookAppointment";
import PhoneandvideoAppointment from "../Components/ScheduleAppointment/PhoneandvideoAppointment";
import AdvocateAvailability from "../Components/ScheduleAppointment/AdvocateAvailability";
import AppointmentTimeSchedule from "../Components/ScheduleAppointment/AppointmentTimeSchedule";
import AppointmentCancellationReschedule from "../Components/ScheduleAppointment/AppointmentCancellationReschedule";
import ChangePassword from "../Components/UserProfileManagement/AccountSetting/ChangePassword";
import NofiticationPreference from "../Components/UserProfileManagement/AccountSetting/NofiticationPreference";
import UpdatePhoneNumber from "../Components/UserProfileManagement/EditProfile/UpdatePhoneNumber";
import UpdateProfileInformation from "../Components/UserProfileManagement/EditProfile/UpdateProfileInformation";
import UpdateAddress from "../Components/UserProfileManagement/EditProfile/UpdateAddress";
import PrivacyPolicy from "../Components/UserProfileManagement/PrivacyPolicy";
import TermsAndConditions from "../Components/UserProfileManagement/TermsAndConditions";
import ContactUs from "../Components/UserProfileManagement/ContactUs";
import Logout from "../Components/UserProfileManagement/Logout";
import WelcomeForm from "../Components/Registration/Welcom_Form";
import Dropdowns from '../CustomControls/dropdowninreact'
import Fertility from "../Components/Trackers/Tracker_Fertility/Fertility";
import FertilityTrends from "../Components/Trackers/Tracker_Fertility/Fertility_Trends";
import AddAppointmentPage from "../QuickAppoinmnet/AddAppointmentPage";
import AddAppointmentModal from "../QuickAppoinmnet/AddAppointmentModal";
import CalendarView from "../Components/ScheduleAppointment/CalendarView";
import TreatmentAuthorization from "../Components/Treatment_Authorization/TreatmentAuthorization";
import Treatment_Upload_Documents from "../Components/Treatment_Authorization/Treatment_Upload_Documents";
import RX_Authorization from "../Components/Prescription/RX_Authorization";
import RX_Review from "../Components/Prescription/RX_Review";
import Review_RX from "../Components/Prescription/Review_RX";
import FeedServices from "../Components/Services/FeedServices";
import SupportServices from "../Components/Support/SuportServices";
import ContinueReading from '../Components/Services/ContinueReading'
import AllSupportServices from "../Components/Support/AllSupportServices";
import ChildDevelopment from "../Components/ChildDevelopment/ChildDevelopment";
import ScrollToTop from "../ScrollTop";
import LoadServiceTitles from "../Components/Education/LoadServiceTitles";
import Andropause from "../Components/Trackers/Tracker_Andropause/Andropause";
import Menopause from "../Components/Trackers/Tracker_Menopause/Menopause";
import RemainderModal from "../Components/Trackers/Tracker_Common/Remainder";
import Refills_Required from "../Components/Prescription/Refills_Required";
import Pregnancy from '../Components/Trackers/Tracker_Pregnancy/Pregnancy';
import TrendGraph from '../Components/Trackers/Tracker_Pregnancy/Pregnancy_Trends'
import DynamicGraph from "../Components/Trackers/Tracker_Pregnancy/Pregnancy_Trends";
import FindProviderNearYou from '../Components/FindCare/FindProviderNearYou';
import PersonalizedProvider from '../Components/FindCare/ProviderSearch';
import FindCare from '../Components/FindCare/FindCare';
import ProviderDirectory from '../Components/FindCare/ProviderDirectory';
import MapSearch from'../Components/FindCare/MapSearch';
import Favorites from'../Components/FindCare/Favorites';
import TopicViewer from "../Components/ChildDevelopment/TopicViewer";
import BenefitDetails from "../Components/WINBenifits/BenefitDetails"
import Benefits_MyDocuments from "../Components/WINBenifits/Benefits_MyDocuments";
import Benefits_PatientID from "../Components/WINBenifits/Benefits_PatientID";
import Benefits_PHIForm from "../Components/WINBenifits/Benefits_PHIForm";
import Benefits_RxAuthorizations from "../Components/WINBenifits/Benefits_RxAuthorizations";
import Benefits_TreatmentCostEstimator from "../Components/WINBenifits/Benefits_TreatmentCostEstimator";
import BenefitsAccumulator from "../Components/WINBenifits/BenefitsAccumulator";
import Benefits_WinMarketPlace from "../Components/WINBenifits/Benefits_WinMarketPlace";
import Benefit_MarketPlaceDetail from "../Components/BenefitMarketPlace/marketPlaceDetail";
import WINBenefit_LandingPage from "../Components/WINBenifits/WINBenefit_LandingPage";
import PDFViewer from  "../Components/WINBenifits/PDFViewer"
import IFramePage from "../Components/FindCare/IFramePage";
import ChatBotWindow from "../Components/ChatBot/ChatBotWindow";
import ShowNote from "../Components/Notifications/ShowNote";
import LoadPdf from "../Components/WINBenifits/LoadPdf"
import Treatmentpackages from "../Components/WINBenifits/Benefits_TreatmentPackages";
import SessionExpired from '../Session/SessionExpired'
import { SessionProvider } from "../Redux/SessionContext";
import PatientConsultation from '../Components/ScheduleAppointment/PatientConsultation';
import ConsultationRating from '../Components/ScheduleAppointment/ConsultationRating';
import WINPayLandingpage from "../Components/WINPay/LandingPage";
import WINPayReaimbursement from "../Components/WINPay/Reimbursement";
import Wincard from "../Components/WINPay/Wincard";

import WINPayTreatmentwithCard from '../Components/WINPay/Treatment_With_Wincard';
import WINPaySupportServiceDocument from '../Components/WINPay/Supporting_Service_Document';
import WINcardDetails from "../Components/WINPay/WINcardDetails";
import CancelAppointment from "../QuickAppoinmnet/CancelAppoinment";
import DocusignIntegration from "../Components/WINPay/docusign";
import DocusignThankYou from "../Components/WINPay/docusignthankyou";
import WINCentiveLandingpage from "../Components/WINCentive/WINCentiveLandingpage";
import HighRiskMaternityAssessment from "../Components/MaternityHighRiskAssessment/MaternityAssessment";
import BHAssessmentForm from "../Components/BHAssessmentForm/BHAssessmentForm";
import RequestAuthorization from "../Components/Treatment_Authorization/VerbalAuth";

import WINCentiveRewardsHistory from "../Components/WINCentive/WINCentiveRewardsHistory";
import WINAchievementsDetails from '../Components/WINCentive/WINAchievementsDetails';
import MultiSelectForm from "../Components/WINCentive/WincentiveStory";
import PlayVideo from "../Components/Support/PlayVideo";
import ViewMoreVideos from "../Components/Support/ViewMoreVideos ";
import WeeklyPregnancyTracker from "../Components/WeeklyPregnancyTracker/WeeklyPregnancyTracker";
import RecipeCard from "../Components/WeeklyPregnancyTracker/RecipeCard";
import BabyDevlopment from "../Components/WeeklyPregnancyTracker/BabyDevelopment";
import PatientCheckinAfterSixMonths from "../Components/CheckinWithYou/patientCheckinAfterSixMonths";
import FourthTrimesterPreviewDeliveryDetails from "../Components/CheckinWithYou/fourthTrimesterPreviewDeliveryDetails";
import FourthTrimesterLandingPage from "../Components/CheckinWithYou/fourthTrimesterLandingPage";
import FourthTrimesterNumberOfBabies from "../Components/CheckinWithYou/fourthTrimesterNumberofBabies";
import FourthTrimesterPregnancyLoss from "../Components/CheckinWithYou/fourthTrimesterPregnancyLoss";
import FourthTrimesterSupport from "../Components/CheckinWithYou/fourthTrimesterSupport";
import FourthTrimesterThankYou from "../Components/CheckinWithYou/fourthTrimesterThankyou";
import FourthTrimesterDeliveryDetails from "../Components/CheckinWithYou/fourthTrimesterDeliveryDetails";
import InsurenceUpload from "../Components/InsurenceUpload/insurenceUpload";
import PrepregnancyDetails from "../Components/HealthProfileSetup/prePregnancyDetails";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import UpdateJourneySelection from "../Components/HealthProfileSetup/UpdateJourneySelection";

import WinPayTiles from "../Components/WINPay/WinPayTiles";
import WinPayNoImplementation from "../Components/WINPay/WinPayNoImplementation";
import BranchListener from '../Components/Branch/BranchListener';
import PatientConsentForm from "../Components/Registration/Patient_Consent_Form";
import New_Authorization from "../Components/Prescription/New_Authorization";
import Request_New_Authorization from "../Components/Prescription/Request_Authorization";
import MinorScreen from "../Components/Registration/MinorScreen";
import WelcomeKit from "../Components/WINBenifits/WelcomeKit";
import MiraIframe from "../Components/Mira/MiraIframe";
import HealthLogMetrix_Fertility from "../Components/Trackers/Tracker_Fertility/HealthLogMetrix_Fertility";
import AffirmativeStatement from '../Components/Layout/AffirmativeStatement';
import CallWin from "../Components/Registration/CallWin";
import Referral_Source from "../Components/Registration/UK_DTC/Referral_Source";
import Paymentstep from "../Components/Registration/UK_DTC/Paymentstep";
import Payment from "../Components/Registration/UK_DTC/Payment";
import PediatricCare from "../Components/ChildDevelopment/PediatricCare";
import RequestModal from "../Components/ChildDevelopment/RequestModal";
import Returntowork from "../Components/MaternityHighRiskAssessment/Returntowork";
import Welcomescreen from "../Components/Registration/Welcomescreen";
import Eligibilityform from "../Components/Registration/Eligibilityform";
import PaymentIframe from "../Components/Registration/UK_DTC/PaymentIframe";
// const SSO_ID = "OMrB35sRtz607siMhukZag%3d%3d";
// const SSO_PARAMS = "D12%2faNBLuwAo3D7Ko79DNblblM2YnF7J0lk3cFbWQ3ZhC7gVyUld45bTedtXDa02i5Qg5ehNbRZLEm5xwuvXOfXTISmxg4MtE5zAN49zEstAdftSxomBny7xCihp3gWE%2f0Db3vFbGHJls09KNODcHg%3d%3d";

// Move isHighmarkPortal to a custom hook
function useIsHighmarkPortal() {
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  return ssoData?.Portal === "Highmark";
}

const DetectSSORoute = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // Check if SSO parameters exist
  const isSSO = searchParams.has("SSO_ID") && searchParams.has("SSO_PARAMS");

  if (isSSO) {
      return <Navigate to={`/login?SSO_ID=${searchParams.get("SSO_ID")}&SSO_PARAMS=${searchParams.get("SSO_PARAMS")}`} replace />;
  }

  return <Navigate to="/login" replace />;
};
  
const DetectFindCareRoute = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);

  // Check if the required query parameters exist for public access
  const memberID = searchParams.get("MemberID");
  const contract = searchParams.get("Contract");
  const deviceType = searchParams.get("DeviceType");

  const isPublic = Boolean(memberID && contract && deviceType); // If these params are present, it's public
  // If it's private and the user is not authenticated, redirect to login
  if (!isPublic && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Handle navigation with query string
  const queryString = location.search;

  // Define the FindCare routes for public and private access
  return (
    <>
      {/* Show header only for authenticated users */}
      {isAuthenticated && <Header />}

      {/* Render FindCare components based on path */}
      {(() => {
        switch (location.pathname) {
          case "/load-findcare-list":
            return <FindProviderNearYou />;
          case "/map-search":
            return <MapSearch />;
          case "/favorites":
            return <Favorites />;
            case "/iframe-page":
            return <IFramePage/>;
          default:
            // If an unknown path, redirect to the first FindCare page
            return <Navigate to={`/load-findcare-list${queryString}`} replace />;
        }
      })()}
    </>
  );
};

const ConditionalLanguageSwitcher = () => {
  const isHighmarkPortal = useIsHighmarkPortal();

  return (
    <div style={{ display: isHighmarkPortal ? "none" : "block" }}>
      <LanguageSwitcher />
    </div>
  );
};


const Routing = () => {
const isAuthenticated = useSelector((state) => state.login.isAuthenticated);

  return (
    <Router>
       <BranchListener />
      <SessionProvider>
      <ScrollToTop />
       {/* <ConditionalLanguageSwitcher />  */}
      <Routes>
        {/* Session Expired Route - Allow access regardless of authentication status */}
        <Route 
    path="/session-expired" 
    element={<SessionExpired />}
/>        {/* Handle both public and private FindCare routes */}
        <Route path="/load-findcare-list" element={<DetectFindCareRoute />} />
        <Route path="/map-search" element={<DetectFindCareRoute />} />
        <Route path="/favorites" element={<DetectFindCareRoute />} />
        <Route path="/iframe-page" element={<DetectFindCareRoute/>}/> 
        {/* Detect and Handle SSO Routing */}
        <Route path="/" element={<DetectSSORoute />} />
        <Route path="/login" element={<PublicRoute element={<Login />} />} />
        {/* <Route path="/" element={<Navigate to={`/login?SSO_ID=${SSO_ID}&SSO_PARAMS=${SSO_PARAMS}`} replace />} />       
        <Route path="/login" element={<PublicRoute element={<Login />} />} />  */}
        <Route path="minorscreen" element={<PublicRoute element={<MinorScreen />} />} />
        <Route path="registration-form-one" element={<PublicRoute element={<RegistrationFormOne/>}/>}/> 
        <Route path="registration-form-two" element={<PublicRoute element={<RegistrationFormTwo isEditMode={false} />} />} />
        <Route path="registration-error" element={<PublicRoute element={<RegistrationError />} />} />
        <Route path="patientconsent-form" element={<PublicRoute element={<PatientConsentForm />} />} />
        <Route path="referral-source" element={<PublicRoute element={<Referral_Source />} />} />
        <Route path="services" element={<PublicRoute element={<Paymentstep />} />} />
        <Route path="payment" element={<PublicRoute element={<Payment />} />} />
        <Route path="pediatric-care" element={<PublicRoute element={<PediatricCare />} />} />
        <Route path="request" element={<PublicRoute element={<RequestModal />} />} />
        <Route path="eligibility" element={<PublicRoute element={<Eligibilityform />} />} />
        <Route path="forgotpassword" element={<PublicRoute element={<Forgot_Password />} />} />
        <Route path="healthprofilesetup" element={<PublicRoute element={<HealthProfileMultiStageForm isEditMode={false} />} />} />
        <Route path="gender" element={<PublicRoute element={<Gender />} />} />
        <Route path="healthplan" element={<PublicRoute element={<HealthPlan />} />} />
        <Route path="welcomekit" element={<PublicRoute element={<WelcomeKit />} />} />
        <Route path="pronouns" element={<PublicRoute element={<Pronouns />} />} />
        <Route path="relationship" element={<PublicRoute element={<Relationship />} />} />
        <Route path="familybuilding-goals" element={<PublicRoute element={<FamilyBuildingGoals />} />} />
        <Route path="familybuilding-journey" element={<PublicRoute element={<FamilyBuildingJourney />} />} />
        <Route path="accesscode" element={<PublicRoute element={<AccessCodeForm />} />} />
        <Route path="companyname" element={<PublicRoute element={<CompanyForm />} />} />
        <Route path="contact-info" element={<CallWin />} />
        <Route path="contracts" element={<PublicRoute element={<ContractsForm />} />} />
        <Route path="contact" element={<PublicRoute element={<ContactWin />} />} />
        <Route path="welcome" element={<PublicRoute element={<Welcomescreen />} />} />
        {/* <Route path="contact-info" element={<CallWin />} /> */}
        <Route path="benefit-options" element={<PublicRoute element={<WinBenefitOptions />} />} />
        <Route path="PhoneandvideoAppointment" element={<PublicRoute element={<PhoneandvideoAppointment />} />} />
        <Route path="AdvocateAvailability" element={<PublicRoute element={<AdvocateAvailability />} />} />
        <Route path="AppointmentTimeSchedule" element={<PublicRoute element={<AppointmentTimeSchedule />} />} />
        <Route path="AppointmentCancellationReschedule" element={<PublicRoute element={<AppointmentCancellationReschedule />} />} />
        
        <Route path="AddAppointmentModal" element={<PublicRoute element={<AddAppointmentModal />} />} />
        <Route path="payment-iframe" element={<PublicRoute element={<PaymentIframe />} />} />
        {/* <Route path="docusignthankyou" element={<PublicRoute element={<DocusignThankYou />} />} /> */}

        {/* Grouping Private Routes */}
        <Route element={<PrivateRoute />}>
          <Route element={<PrivateLayout />}>
                  <Route
                    path="home"
                    element={
                    // useIsHighmarkPortal() ? <Home /> : 
                    <Home_W />
                    }
                  />
                  <Route path="edit-healthprofilesetup" element={<HealthProfileMultiStageForm isEditMode={true} />} />
                  <Route path="updateaddress" element={<UpdateAddress isEditMode={true} />} />
                  <Route path="contact-us" element={<ContactUs />} />
                  <Route path="CallWin" element={<CallWin />} />
                  <Route path="welcomeform" element={<WelcomeForm />} />
                  <Route path="notification-preference" element={<NofiticationPreference />} />
                  <Route path="change-password" element={<ChangePassword />} />
                  <Route path="docusignthankyou" element={<DocusignThankYou />} />   
                  <Route path="updatejourneyselection" element={<PublicRoute element={<UpdateJourneySelection />} />} />

                  {/* Schedule Appointment routes */}
            <Route path="book-appointment" element={<BookAppointment />} />
            <Route path="calendar-view" element={<CalendarView />} />
            <Route path="phone-video-appointment" element={<PhoneandvideoAppointment />} />
            <Route path="schedule-time-slot" element={<AppointmentTimeSchedule />} />
            <Route path="appointment-cancellation-reschedule" element={<AppointmentCancellationReschedule />} />
            <Route path="patientconsultation" element={<PatientConsultation />} />
            <Route path="consultation-rating" element={<ConsultationRating />} />
            <Route path="feedServices" element={<FeedServices />} />
            <Route path="continuereading" element={<ContinueReading />} />
            {/* User Profile Management Routes */}
            
            <Route path="updatephonenumber"  element={<UpdatePhoneNumber isEditMode={true} />} />
            {/* <Route path="UpdateProfileInformation" element={<PublicRoute element={<UpdateProfileInformation />} />} /> */}
            <Route path="edit-UpdateProfileInformation" element={<UpdateProfileInformation />} />
            <Route path="PrivacyPolicy" element={<PublicRoute element={<PrivacyPolicy />} />} />
            <Route path="TermsAndConditions" element={<PublicRoute element={<TermsAndConditions />} />} />
            <Route path="Logout" element={<PublicRoute element={<Logout />} />} />

            {/* Treatment Authorization Routes */}
            <Route path="treatment-authorization" element={<TreatmentAuthorization />} />
            <Route path="treatment-upload-documents" element={<Treatment_Upload_Documents />} />
            <Route path="verbal-authorization" element ={<RequestAuthorization/>}/>

            {/* Prescription Routes */}
            <Route path="rx-authorization" element={<RX_Authorization />} />
            <Route path="rx-review" element={<RX_Review />} />
            <Route path="review-rx" element={<Review_RX />} />
            <Route path="refills-required" element={<Refills_Required />} />
            <Route path="new-authorization" element={<New_Authorization />} />
            <Route path="request-authorization" element={<Request_New_Authorization />} />
              <Route path="return-to-work-support" element={<Returntowork />}  />

            {/* support module */}
            <Route path="support-services" element={<SupportServices />} />
            <Route path="allsupport-services" element={<AllSupportServices />} />
            <Route path="child-development" element={<ChildDevelopment />} />
            <Route
                    path="/child-development/:selectedPath"
                    element={<TopicViewer />}
                />



            {/* Andropause Tracker */}
            <Route path="andropause" element={<Andropause />} />
            <Route path="remainder" element={<RemainderModal  />} />
            {/* Pregnancy Tracker */}
            <Route path="pregnancy" element={<Pregnancy  />} />
            <Route path="seetrends" element={<TrendGraph  />} />
            <Route path="graph" element={<DynamicGraph  />} />
            

            <Route path="fertility" element={<Fertility  />} />
            <Route path="fertility-trends" element={<FertilityTrends />} />
            <Route path="fertility-health-log-metrics" element={< HealthLogMetrix_Fertility/>} />
            <Route path="AddAppointmentPage" element={<PublicRoute element={<AddAppointmentPage />} />} />
            
            {/* Education Module */}
            <Route path="load-service-titles" element={<LoadServiceTitles />} />
            <Route path="dropdowns" element={<Dropdowns  />} />
            
            {/* menopause Tracker */}
            <Route path="menopause" element={<Menopause  />} />

            {/* Find Care */}
            <Route path="load-findcare-list" element={<FindProviderNearYou/>} />
            <Route path="find-care" element={<FindCare/>} />
            <Route path="provider-directory" element={<ProviderDirectory/>} />
            <Route path="map-search" element={<MapSearch/>} />
            <Route path="favorites" element={<Favorites/>} />
            <Route path="/iframe-page" element={<IFramePage/>}/> 
            <Route path="personalized-providers" element={<PersonalizedProvider/>} />

             {/* WIN Benefits */}
            <Route path="benefit-details" element={<BenefitDetails/>}/>
            <Route path="benefits-mydocuments" element={<Benefits_MyDocuments/>}/>
            <Route path="benefit-patientid" element={<Benefits_PatientID/>}/>
            <Route path="benefits-phiform" element={<Benefits_PHIForm/>}/>
            {/* <Route path="winbenefit-request-reimbursement" element={<Benefits_RequestReimbursement/>}/> */}
            <Route path="benefits-rxauthorization" element={<Benefits_RxAuthorizations/>}/>
            <Route path="benefits-treatmentcostestimator" element={<Benefits_TreatmentCostEstimator/>}/>
            <Route path="benefits-winmarketplace" element={<Benefits_WinMarketPlace/>}/>
            <Route path="winmarketplace-info" element={<Benefit_MarketPlaceDetail/>}/>
            <Route path="benefits-treatmentpackages" element={<Treatmentpackages/>}/>
            
            {/* <Route path="winbenefit-treatmentauthorizations" element={<Benefits_TreatmentAuthorizations/>}/>  */}
            <Route path="benefits-accumulator" element={<BenefitsAccumulator/>}/> 
            <Route path="benefits-landingpage" element={<WINBenefit_LandingPage/>}/> 
            <Route path="iframe-page" element={<IFramePage/>}/> 
            <Route path="pdf-viewer" element={<PDFViewer />} />
            <Route path="load-pdf" element={<LoadPdf />} />

            {/* mira */}
            <Route path="miraiframe" element={<MiraIframe />} />

            {/* Chat Bot Window */}
            <Route path="chat-bot" element={<ChatBotWindow/>}/>

            {/* NotificationList */}
            <Route path="notifications" element={<ShowNote />} />   
            <Route path ="cancelappoinment" element={<CancelAppointment />} />

            <Route path="bhassessment" element={<BHAssessmentForm />} />
            <Route path="incentive-story" element={<MultiSelectForm />} />

            {/* WeeklyPregnancyTracker */}
            <Route path="weekly-pregnancy-tracker" element={<WeeklyPregnancyTracker />} />
            <Route path="recipe-card" element={<RecipeCard />} />
            <Route path="baby-devlopment" element={<BabyDevlopment/>} />
         

            {/* WINPay    */}
            <Route path="pay-landingpage" element={<WINPayLandingpage />} />   
            <Route path="pay-reimbursement" element={<WINPayReaimbursement />} />   
            <Route path="pay-treatmentwithCard" element={<WINPayTreatmentwithCard />} />   
            <Route path="pay-supportservicedocument" element={<WINPaySupportServiceDocument />} />   
            
            <Route path="pay-cards" element={<Wincard />} />   
            <Route path="card-details" element={<WINcardDetails />} />   
            <Route path="docusign" element={<DocusignIntegration />} />
            <Route path="pay-tiles" element={<WinPayTiles/>}/>
            <Route path="pay-noimplementation" element={<WinPayNoImplementation/>}/>

            {/* WINPay    */}   
            <Route path="maternity-assessment" element={<HighRiskMaternityAssessment />} />

            <Route path="incentive-landingpage" element={<WINCentiveLandingpage />} />
            <Route path="incentive-rewardshistory" element={<WINCentiveRewardsHistory />} />
            <Route path="incentive-achievementdetails" element={<WINAchievementsDetails />} />
            <Route path="/play-video" element={<PlayVideo />} />
            <Route path="/view-more-videos" element={<ViewMoreVideos />} />

            {/* Checkinwithyou */}
            <Route path="fourth-trimester-landing-page" element={<PatientCheckinAfterSixMonths />} />
      <Route path="fourth-trimester-delivery-details" element={<FourthTrimesterDeliveryDetails />} />
      <Route path="patient-checkin-after-six-months" element={<FourthTrimesterLandingPage />} />
      <Route path="fourth-trimester-number-of-babies" element={<FourthTrimesterNumberOfBabies />} />
      <Route path="fourth-trimester-pregnancy-loss" element={<FourthTrimesterPregnancyLoss />} />
      <Route path="fourth-trimester-preview-delivery-details" element={<FourthTrimesterPreviewDeliveryDetails />} />
      <Route path="fourth-trimester-support" element={<FourthTrimesterSupport />} />
      <Route path="fourth-trimester-thank-you" element={<FourthTrimesterThankYou />} />

      {/* insurenceupload */}
      <Route path="insurenceupload" element={<InsurenceUpload />} />
      <Route path="prepregnancydetails" element={<PrepregnancyDetails />} />

            {/* Affirmative Statement */}
            <Route path="affirmative-statement" element={<AffirmativeStatement />} />

          </Route>
        </Route>
      </Routes>
      </SessionProvider>
    </Router>
  );
};

export default Routing;
